const resetCSS = {
  resize: "none",
  border: "none",
  outline: "none",
  boxShadow: "none",
};

export default resetCSS;
